
import { RouterModule, Routes } from '@angular/router';

export const custom: Routes = [

  {path:'SUPERADMIN',children:[
   {
  path: 'dashboard',
  loadComponent: () =>
    import('../../componets/dashboard/products/products.component').then((m) => m.ProductsComponent),
},
 ]}
]